"use client";

import { CircleXIcon, InfoIcon } from "lucide-react";
import type { ChatQuotaTierIndicatorState } from "./chat-quota-view-state";

type Props = {
  state: ChatQuotaTierIndicatorState;
};

export function ModelSelectQuotaStatusIndicator({ state }: Props) {
  if (state.kind === "hidden") {
    return null;
  }

  return state.kind === "warning" ? (
    <span
      data-slot="model-select-quota-indicator"
      data-state="warning"
      className="inline-flex h-[15px] w-[15px] shrink-0 items-center justify-center text-muted-foreground/75"
    >
      <InfoIcon aria-hidden className="h-[15px] w-[15px]" strokeWidth={2.2} />
    </span>
  ) : (
    <span
      data-slot="model-select-quota-indicator"
      data-state="exceeded"
      className="inline-flex h-4 w-4 shrink-0 items-center justify-center text-destructive/80"
    >
      <CircleXIcon aria-hidden className="h-4 w-4" strokeWidth={2.25} />
    </span>
  );
}
